import Vue from 'vue'

import {achost, DEFAULT_HEADERS} from '../constants';

const state = () => ({
    policies: [],
    unapprovedPolicies: []
});
//https://apex-connect.avalanchestudios.com/api/v1/acp/portal/policies
//${achost}/api/v1/acp/portal/policies
const actions = {
    getPolicies(context) {
        return Vue.axios.post(`${achost}/api/v1/acp/portal/policies`, {}, {
            headers: DEFAULT_HEADERS
        }).then(function(resp) {
            context.commit('setPolicies', resp.data.policies);
        })
    },
    getUnnaprovedPolicies(context, payload) {
        const approved = Array.isArray(payload) ? payload : [];
        return Vue.axios.post(`${achost}/api/v1/acp/portal/policies`, {}, {
            headers: DEFAULT_HEADERS
        }).then(function(resp) {
            const policies = resp.data.policies || [];
            const unapprovedPolicies = policies.filter(policy => {
                return !approved.some(a =>
                    a.policy_identifier === policy.identifier &&
                    String(a.policy_version_id) === String(policy.version)
                );
            });
            context.commit('setUnapprovedPolicies', unapprovedPolicies);
            return unapprovedPolicies;
        })
    },
    approvePolicy(context, payload) {
        return Vue.axios.post(
            `${achost}/api/v1/acp/portal/policies/accept`, 
            {
                policy_identifier: payload.policy.identifier,
                policy_version_id: payload.policy.version,
                text_hash: payload.policy.sha256
            },
            {
                headers: {
                    ...DEFAULT_HEADERS,
                    'X-Ava-Authorization': payload.token
                }
            })
    }
}


const mutations = {
    setPolicies(state, value) {
        state.policies = value;
    },
    setUnapprovedPolicies(state, value) {
        state.unapprovedPolicies = value;
    }
}

export const policies = {
    namespaced:true,
    actions,
    mutations,
    state
}
